module.exports = __webpack_public_path__ + "static/img/jq-role-r.52e3928.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jq/jq-role-r.png
// module id = +k/Q
// module chunks = 1